require(136);
module.exports = require(58).Object.assign;
